import React, { useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Helmet } from "react-helmet-async";
import { website } from "../constants/website";
import { services } from "../constants/servicesDetails";
import api from "../constants/api";
import moment from "moment";

export default function ContactUs() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState({
    name: "",
    surname: "",
    dob: "",
    phoneNumber: "",
    alternateNumber: "",
    email: "",
    gender: "",
    service: {
      name: "",
      paymentMethod: "Cash Payment",
    },
    notes: "",
    appointmentDate: "",
    appointmentTime: "",
    referralForms: [],
    idPassportNumber: "",
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "paymentMethod") {
      setData((prev) => ({
        ...prev,
        service: { ...prev.service, paymentMethod: value },
      }));
    } else if (name === "serviceName") {
      setData((prev) => ({
        ...prev,
        service: { ...prev.service, name: value },
      }));
    } else {
      setData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleFileChange = (e: any) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await api.post(
          "/cloudinary/upload/referrals_forms",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        addAppointment(response.data.data);
      } catch (err) {
        console.error("File upload error:", err);
        setError("Failed to upload the file. Please try again.");
        setLoading(false);
      }
    } else {
      addAppointment(null);
    }
  };

  const addAppointment = (fileObj: any) => {
    let files: any = [];
    if (fileObj) {
      let obj = {
        url: fileObj.url,
        publicId: fileObj.publicId,
        name: fileObj.fileName,
      };

      files.push(obj);
    }
    data.referralForms = files;
    data.appointmentDate = moment(data.appointmentDate).format("YYYY-MM-DD");
    data.appointmentTime = moment().format("HH:mm");

    api
      .post("/appointment/public/appointments", data)
      .then(() => {
        window.alert("Your appointment has been scheduled successfully!");
        // window.location.reload();
      })
      .catch((error) => {
        console.error("Error scheduling appointment:", error);
        window.alert("An error occurred. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>{website.CONTACT.title}</title>
        <meta name="description" content={website.CONTACT.description} />
        <meta name="keywords" content={website.CONTACT.keywords} />
      </Helmet>
      <div className="page">
        <Header></Header>
        <div className="site-main">
          <section className="prt-row prt-bg bg-base-grey contact-section contact-border-top clearfix">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-md-10 col-sm-11 m-auto">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">
                      <h3 className="prt-contact-pretitle">Contact</h3>
                      <h2 className="title" style={{ fontSize: 40 }}>
                        Schedule an Appointment
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="prt_contact_widget_wrapper mt-55 res-991-mt-20">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="prt_contact-title-block bg-base-gradient">
                          <div className="section-title">
                            <div className="title-header text-base-white">
                              <h2 className="title">Our booking policy</h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="prt_content-block">
                        <div className="row g-0">
                          <div className="col-xl-6 col-lg-12">
                            <div className="pr-40 res-991-pr-0">
                              <ul>
                                <li>
                                  <strong>Booking Requirements</strong>
                                  <ul>
                                    <li>
                                      Provide accurate contact info and required medical details during booking.
                                    </li>
                                    <li>
                                      Bring a valid ID and medical aid card to
                                      your appointment.
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  <strong>Appointment Times</strong>
                                  <ul>
                                    <li>
                                      Arrive 15 minutes early to speed up registration and payment.
                                    </li>
                                    <li>Contact us at least 24 hours in advance to change your appointment.</li>
                                  </ul>
                                </li>
                                <li>
                                  <strong>Payments</strong>
                                  <ul>
                                    <li>
                                      Payments for exams must be made at Prime
                                      Precision Imaging at the time of service.
                                    </li>
                                    <li>
                                      We accept the following medical aid
                                      policies: BPOMAS and PULA.
                                    </li>
                                    <li>
                                      Any co-payments are due at the time of
                                      service.
                                    </li>
                                  </ul>
                                </li>

                                <li>

                                  <strong>Late Arrivals</strong>
                                  <ul>
                                    <li>
                                      We will try to accommodate you, but late arrivals may result in reduced exam time or rescheduling.
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-xl-6 col-lg-12">
                            <div className="prt-contact-form">
                              <h3>Schedule an Appointment</h3>
                              <form
                                onSubmit={handleSubmit}
                                className="query_form-1 wrap-form clearfix"
                              >
                                <div className="row mt-2">
                                  <div className="col-md-6 mt-2">
                                    <label>Name</label>
                                    <input
                                      name="name"
                                      type="text"
                                      value={data.name}
                                      onChange={handleInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Surname</label>
                                    <input
                                      name="surname"
                                      type="text"
                                      value={data.surname}
                                      onChange={handleInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Date of Birth</label>
                                    <input
                                      name="dob"
                                      type="date"
                                      value={data.dob}
                                      onChange={handleInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Phone Number</label>
                                    <input
                                      name="phoneNumber"
                                      type="number"
                                      value={data.phoneNumber}
                                      onChange={handleInputChange}
                                      placeholder="eg. 2677***"
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Alternate Number</label>
                                    <input
                                      name="alternateNumber"
                                      type="number"
                                      placeholder="eg. 2677***"
                                      value={data.alternateNumber}
                                      onChange={handleInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Email</label>
                                    <input
                                      name="email"
                                      type="email"
                                      value={data.email}
                                      onChange={handleInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>ID/Passport Number</label>
                                    <input
                                      name="idPassportNumber"
                                      type="text"
                                      value={data.idPassportNumber}
                                      onChange={handleInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label> Service Requested</label>
                                    <select
                                      name="serviceName"
                                      value={data.service.name}
                                      onChange={handleInputChange}
                                      required
                                    >
                                      <option value="">
                                        - Select Service -
                                      </option>
                                      {services.map((s) => (
                                        <option
                                          key={s.displayname}
                                          value={s.displayname}
                                        >
                                          {s.displayname}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Gender</label>

                                    <select
                                      name="gender"
                                      value={data.gender}
                                      onChange={handleInputChange}
                                      required
                                    >
                                      <option value="">Gender</option>
                                      <option value="Male">Male</option>
                                      <option value="Female">Female</option>
                                      <option value="Other">Other</option>
                                    </select>
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Payment Method</label>
                                    <select
                                      name="paymentMethod"
                                      value={data.service.paymentMethod}
                                      onChange={handleInputChange}
                                      required
                                    >
                                      <option value="cash">Cash Payment</option>
                                      <option value="Bpomas">Bpomas</option>
                                      <option value="Pula Medical Aid">Pula Medical Aid</option>
                                    </select>
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Referral Form</label>
                                    <input
                                      type="file"
                                      onChange={handleFileChange}
                                    />
                                  </div>
                                  <div className="col-md-6 mt-2">
                                    <label>Appointment Date</label>
                                    <input
                                      name="appointmentDate"
                                      type="date"
                                      value={data.appointmentDate}
                                      onChange={handleInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-12 mt-2">
                                    <label>Additional Notes</label>
                                    <textarea
                                      name="notes"
                                      value={data.notes}
                                      onChange={handleInputChange}
                                    ></textarea>
                                  </div>
                                  <div className="col-md-12 mt-2">
                                  <button
                                    className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor"
                                    type="submit"
                                    disabled={loading}
                                  >
                                    {loading ? "Submitting..." : "Submit"}
                                  </button>
                                  <br />
                                  {loading && (
                                    <div className="d-flex justify-content-center mt-2">
                                      <div className="loading-indicator">Processing your request... Please wait.!</div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </form>
                            {error && <p style={{ color: "red" }}>{error}</p>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer></Footer>
    </div>
  </>
);
}
